import { Link } from 'react-router-dom';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import SectionTitle from '@/components/base/SectionTitle';
import VideoCard from '@/components/feature/VideoCard';
import NewsListItem from '@/components/feature/NewsListItem';
import { getHotVideos, getLatestVideos, getLatestNews, filterHistory } from '@/utils/media';
import { useHistory } from '@/hooks/useHistory';

export default function Home() {
  const hotVideos = getHotVideos(10);
  const latestVideos = getLatestVideos(10);
  const news = getLatestNews(5);
  const { history } = useHistory();
  const historyVideos = filterHistory(history).slice(0, 6);

  return (
    <>
      <HeroCarousel items={hotVideos.slice(0, 5)} />
      <CategoryEntries />

      {historyVideos.length > 0 && (
        <section className="mx-auto w-full max-w-[1280px] px-4 pb-4 md:px-8">
          <SectionTitle
            title="继续观看"
            subtitle="根据你的浏览记录推荐"
            icon="ri-history-line"
            accent="secondary"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {historyVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </section>
      )}

      <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-8 md:py-12">
        <SectionTitle
          title="热门影视推荐"
          subtitle="观众点播热度最高的作品"
          icon="ri-fire-line"
          moreTo="/category/movie"
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {hotVideos.slice(0, 10).map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </section>

      <section className="border-y border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-8 md:py-12">
          <SectionTitle
            title="最新影视更新"
            subtitle="按更新时间倒序，追剧不错过"
            icon="ri-timer-flash-line"
            accent="accent"
            moreTo="/news"
            moreLabel="查看资讯"
          />
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
            {latestVideos.slice(0, 10).map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-8 md:py-12">
        <SectionTitle
          title="影视资讯精选"
          subtitle="掌握最新影视动态与深度专题"
          icon="ri-newspaper-line"
          moreTo="/news"
        />
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {news.map((item) => (
            <NewsListItem key={item.id} item={item} />
          ))}
        </div>
        <div className="mt-6 sm:hidden">
          <Link
            to="/news"
            className="flex items-center justify-center gap-1 rounded-md border border-background-200 py-3 text-sm text-foreground-300"
          >
            查看更多资讯
            <i className="ri-arrow-right-s-line text-lg" />
          </Link>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 pb-4 md:px-8">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-gradient-to-br from-background-100 to-background-200/60 p-8 md:p-10">
          <div className="max-w-2xl">
            <h2 className="text-2xl font-bold text-foreground-50 md:text-3xl">
              关于<span className="text-primary-500">黄牛视频</span>
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-300 md:text-base">
              黄牛视频是一个高清影视视频资源聚合平台，汇聚电影、电视剧、综艺等多元内容，并提供及时的影视资讯。
              我们致力于用简洁高效的方式，帮助你快速找到想看的作品，让每一次观影都从轻松浏览开始。
            </p>
          </div>
          <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-4">
            {[
              { num: '12,000+', label: '影视资源' },
              { num: '3,600+', label: '剧集连载' },
              { num: '800+', label: '综艺节目' },
              { num: '每日', label: '资讯更新' },
            ].map((stat) => (
              <div key={stat.label} className="rounded-lg bg-background-50/70 p-4">
                <p className="text-xl font-bold text-accent-500 md:text-2xl">{stat.num}</p>
                <p className="mt-1 text-sm text-foreground-400">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}